import * as ACTIONS from 'constant/action/help'
import * as LOADER_ACTIONS from 'constant/action/loader'
import { createAction } from 'redux-actions'
import buildFileMeta from 'helper/build-file-meta'

const updateHelpContent = createAction(ACTIONS.UPDATE_HELP_CONTENT)
const updateHelpSubmitting = createAction(LOADER_ACTIONS.UPDATE_HELP_SUBMITTING)
const updateLoading = createAction(LOADER_ACTIONS.UPDATE_LOADING)

export const getHelp = () => async (dispatch, getState, { help }) => {
  dispatch(updateLoading(true))
  const helpObject = await help.getHelp()

  if (helpObject.uuid) {
    const html = await help.getHelpHtml(helpObject.signed_url)

    dispatch(updateHelpContent({
      html,
      show: helpObject.show,
      uuid: helpObject.uuid
    }))
  }

  dispatch(updateLoading(false))
}

export const editHelp = (helpHtmlString, show) => async (dispatch, getState, { help }) => {
  try {
    dispatch(updateHelpSubmitting(true))
    const {
      help: {
        help: { uuid }
      }
    } = getState()
    const {
      file: helpFile, meta: fileMeta
    } = buildFileMeta(helpHtmlString, 'help-file')

    const editedHelp = {
      file_meta: fileMeta,
      show,
      uuid
    }
    const response = await help.editHelp(editedHelp)

    if (helpFile) {
      await help.uploadFile(response.url, helpFile)
    }

    dispatch(updateHelpSubmitting(false))
    dispatch(getHelp())
    return editedHelp
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}
